import React, { useState, useRef } from "react";
import { Drawer, Form, Input, Icon, notification, Select, Modal } from "antd";
import axios from "axios";
import moment from "moment";

import EditorHtml from "../../../shared/components/Form/EditorHtml";

import { cleanHtmlContent } from "../../../shared/utils/Diario/htmlCleanner";

import { noimage } from "../../../assets";

const { TextArea } = Input;
const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

const DrawerAdicionarParecer = ({
    disciplinaId,
    parecerInfo,
    periodoId,
    visible,
    onClose,
    onConfirm,
    form,
    onRascunhoGuardado,
    onRascunhoGeralGuardado,
    apagarRascunnhoGeral,
    apagarRascunnhoParticipante
}) => {
    const [participante, setParticipante] = useState(null);
    const [parecer, setParecer] = useState("");
    const [iconLoading, setIconLoading] = useState(false);
    const [editorVisible, setEditorVisible] = useState(false);

    const editorRef = useRef(null);
    //const debounceRef = useRef(null);
    const parecerInicialRef = useRef("");
    const teclaPremiodaRef = useRef(false);
    const rascunhoGuardadoRef = useRef(false);

    const normalizeHtml = html => {
        if (!html) return "";
        return html.replace(/\s+/g, " ").trim();
    };

    const handleEditorChange = conteudo => {
        if (!teclaPremiodaRef.current) return;

        if (!visible) return;

        if (normalizeHtml(conteudo) === normalizeHtml(parecerInicialRef.current)) return;

        rascunhoGuardadoRef.current = true;

        // if (debounceRef.current) {
        //     clearTimeout(debounceRef.current);
        // }

        // debounceRef.current = setTimeout(() => {
        //     if (participante?.id) {
        //         guardarRascunho();
        //     } else {
        //         guardarRascunhoGeral();
        //     }
        // }, 500);
    };

    const guardar = () => {
        form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                setIconLoading(true);

                const utilizadorId = participante?.id;
                const cleanContent = cleanHtmlContent(editorRef.current.value);
                const _parecer = cleanContent;

                var item = new FormData();
                if (utilizadorId) item.append("utilizadorId", utilizadorId);
                item.append("turmaId", disciplinaId);
                item.append("periodoId", periodoId);
                item.append("parecer", _parecer);

                axios({
                    method: "put",
                    url: utilizadorId ? "/api/pareceres/guardar-paracer-aluno" : "/api/pareceres/guardar-paracer-geral",
                    data: item
                })
                    .then(() => {
                        openNotificationWithIcon("success", "Sucesso", "Parecer adicionado!");
                        onConfirm(_parecer);
                        parecerInicialRef.current = "";
                        parecerInfo.parecer_rascunho = null;
                        setIconLoading(false);
                    })
                    .catch(() => {
                        openNotificationWithIcon("error", "Erro", "Não foi possível guardar o parecer!");

                        setIconLoading(false);
                    });
            }
        });
    };

    const guardarRascunho = () => {
        const utilizadorId = participante?.id;
        const cleanContent = cleanHtmlContent(editorRef.current.value);

        var item = new FormData();
        if (utilizadorId) item.append("utilizadorId", utilizadorId);
        item.append("turmaId", disciplinaId);
        item.append("periodoId", periodoId);
        item.append("parecer_rascunho", cleanContent);
        item.append("dt_rascunho_rascunho", moment().format("YYYY-MM-DD"));

        axios({
            method: "put",
            url: "/api/pareceres/guardar-paracer-aluno-rascunho",
            data: item
        })
            .then(() => {
                //rascunhoGuardadoRef.current = true;
                if (onRascunhoGuardado && utilizadorId) {
                    openNotificationWithIcon("success", "Rascunho guardado", "Os dados foram salvos como rascunho.");
                    onRascunhoGuardado(utilizadorId, cleanContent, new Date().toISOString());
                }
            })

            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível guardar o rascunho!");
            });
    };

    const guardarRascunhoGeral = () => {
        const cleanContent = cleanHtmlContent(editorRef.current.value);

        var item = new FormData();
        item.append("turmaId", disciplinaId);
        item.append("periodoId", periodoId);
        item.append("parecer", cleanContent);

        axios({
            method: "put",
            url: "/api/pareceres/guardar-paracer-geral-rascunho",
            data: item
        })
            .then(() => {
                //rascunhoGuardadoRef.current = true;
                if (onRascunhoGeralGuardado) {
                    openNotificationWithIcon("success", "Rascunho guardado", "Os dados foram salvos como rascunho.");
                    onRascunhoGeralGuardado(cleanContent, new Date().toISOString());
                }
            })
            .catch(() => {
                openNotificationWithIcon("error", "Erro", "Não foi possível guardar o rascunho!");
            });
    };

    const cancelarRascunho = () => {
        axios({
            method: "delete",
            url: "/api/pareceres/cancelar-parecer-geral",
            params: {
                turmaId: localStorage.getItem("codigo_curso"),
                periodoId: periodoId
            }
        })
            .then(() => {
                openNotificationWithIcon("success", "Sucesso", "Rascunho descartado.");
                apagarRascunnhoGeral();
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error?.data?.message || "Não foi possível descartar o rascunho.");
            });
    };

    const cancelarRascunhoParticipante = () => {
        axios({
            method: "delete",
            url: "/api/pareceres/cancelar-parecer-participante",
            params: {
                turmaId: localStorage.getItem("codigo_curso"),
                periodoId: periodoId,
                utilizadorId: parecerInfo.participante?.id
            }
        })
            .then(() => {
                openNotificationWithIcon("success", "Sucesso", "Rascunho descartado.");
                apagarRascunnhoParticipante();
            })
            .catch(error => {
                openNotificationWithIcon("error", "Erro", error?.data?.message || "Não foi possível descartar o rascunho.");
            });
    };

    const mostrarModalRascunho = (parecerOriginal, parecerRascunho, dtRascunho, onAceitar) => {
        setParecer(parecerOriginal);
        parecerInicialRef.current = parecerOriginal;

        const content = dtRascunho
            ? `Existe um rascunho guardado para esta aula a ${moment(dtRascunho).format(
                  "DD/MM/YYYY [às] HH:mm"
              )}. Deseja carregar os dados do rascunho?`
            : "Existe um rascunho guardado para este parecer. Deseja carregar os dados do rascunho?";

        if (parecerRascunho && normalizeHtml(parecerRascunho) !== normalizeHtml(parecerOriginal)) {
            Modal.confirm({
                title: "Rascunho encontrado",
                content: content,
                okText: "Sim, carregar",
                cancelText: "Não",
                onOk: onAceitar,
                onCancel: parecerInfo.participante ? cancelarRascunhoParticipante : cancelarRascunho
            });
        }
    };

    const onCloseDrawer = () => {
        if (rascunhoGuardadoRef.current) {
            if (participante?.id) {
                guardarRascunho();
            } else {
                guardarRascunhoGeral();
            }
        }

        onClose();
    };

    const afterVisibleChange = aberto => {
        if (aberto) {
            form.resetFields();
            setEditorVisible(true);

            if (parecerInfo.participante) {
                setParticipante(parecerInfo.participante);

                const parecerOriginal = parecerInfo.participante.parecer;
                const parecerRascunho = parecerInfo.participante.parecer_rascunho;
                const dtRascunho = parecerInfo.participante.dt_parecer_rascunho;

                mostrarModalRascunho(parecerOriginal, parecerRascunho, dtRascunho, () => {
                    setParecer(parecerRascunho);
                    parecerInicialRef.current = parecerRascunho;
                });
            } else {
                setParticipante(null);

                const parecerGeralOriginal = parecerInfo.textoParecerGeral;
                const parecerGeralRascunho = parecerInfo.textoParecerGeralRascunho;
                const dtRascunhoGeral = parecerInfo.dtParecerGeralRascunho;

                mostrarModalRascunho(parecerGeralOriginal, parecerGeralRascunho, dtRascunhoGeral, () => {
                    setParecer(parecerGeralRascunho);
                    parecerInicialRef.current = parecerGeralRascunho;
                });
            }
        } else {
            setEditorVisible(false);
            parecerInicialRef.current = "";
            teclaPremiodaRef.current = false;
            rascunhoGuardadoRef.current = false;
        }
    };

    return (
        <>
            <Drawer
                title={`Preencher o ${participante ? "parecer individual" : "parecer geral"}`}
                className="drawer-from-pagina-html"
                width={720}
                onClose={onCloseDrawer}
                visible={visible}
                style={{
                    overflow: "auto",
                    height: "calc(100% - 108px)",
                    paddingBottom: "108px"
                }}
                maskClosable={false}
                afterVisibleChange={afterVisibleChange}
            >
                <div>
                    {participante && (
                        <div className="bloco info-participante">
                            <div className="container-img">
                                <img src={participante.foto ? participante.foto : noimage} />
                            </div>
                            <div className="info" style={{ flex: "fit-content" }}>
                                <span className="nome">{participante.nome}</span>
                                <p className="numero">{participante.numero}</p>
                            </div>
                        </div>
                    )}
                    <div
                        className="bloco"
                        onKeyDown={() => {
                            teclaPremiodaRef.current = true;
                        }}
                        onPaste={() => {
                            teclaPremiodaRef.current = true;
                        }}
                    >
                        {editorVisible && (
                            <EditorHtml
                                onChange={handleEditorChange}
                                value={parecer}
                                disabledPlugins="addnewline,cleanhtml,clipboard,draganddrop,draganddropelement,paste,pastestorage,errormessages,formatblock,imageprocessor,imageproperties,inlinepopup,limit,media,tablekeyboardnavigation,tooltip"
                                activeButtonsInReadOnly={["source", "fullsize", "print", "about"]}
                                buttons="bold,strikethrough,underline,italic,eraser,|,ul,ol,|,fontsize,brush,paragraph,|,align,undo,redo,|,fullsize"
                                editorRef={editorRef}
                            />
                        )}
                    </div>
                </div>
                <div className="ant-drawer-footer">
                    <button
                        className="botao-secundario"
                        // onClick={() => {
                        //     if (rascunhoGuardadoRef.current)
                        //         openNotificationWithIcon("success", "Rascunho guardado", "Os dados foram salvos como rascunho.");
                        //     rascunhoGuardadoRef.current = false;
                        //     onClose();
                        // }}
                        onClick={onCloseDrawer}
                        style={{ marginRight: 20, display: "inline-block" }}
                    >
                        Voltar
                    </button>
                    <button className="botao-principal" onClick={guardar} disabled={iconLoading} type="primary">
                        {iconLoading ? <Icon type="loading" /> : null}
                        Salvar
                    </button>
                </div>
            </Drawer>
        </>
    );
};

const FormDrawerAdicionarParecer = Form.create({ name: "form-drawer-adicionar-parecer" })(DrawerAdicionarParecer);

export default FormDrawerAdicionarParecer;
